import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function LanguageToggle() {
  const {
    lang,
    setLang
  } = useLanguage();
  const [hasInteracted, setHasInteracted] = useState(false);
  const handleSetLang = (newLang: 'en' | 'es') => {
    setLang(newLang);
    setHasInteracted(true);
  };
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-103">
      {/* Pulsing neon glow behind the toggle — pure CSS */}
      {!hasInteracted && <div aria-hidden="true" className="toggle-glow-anim absolute -inset-2 rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(250,255,0,0.4) 0%, rgba(250,255,0,0) 70%)',
      filter: 'blur(10px)'
    }} data-id="element-104" />}

      {/* Toggle pill */}
      <div className={`relative flex items-center backdrop-blur-md rounded-full p-1 shadow-lg ${!hasInteracted ? 'toggle-ring-anim' : 'border border-border'}`} style={{
      background: 'rgba(255,255,255,0.05)'
    }} data-id="element-105">
        <button onClick={() => handleSetLang('en')} className={`px-3 py-1.5 rounded-full text-xs font-mono font-bold transition-colors ${lang === 'en' ? 'bg-brand text-black' : 'text-ink-dim hover:text-ink'}`} data-id="element-106">
          EN
        </button>
        <button onClick={() => handleSetLang('es')} className={`px-3 py-1.5 rounded-full text-xs font-mono font-bold transition-colors ${lang === 'es' ? 'bg-brand text-black' : 'text-ink-dim hover:text-ink'}`} data-id="element-107">
          ES
        </button>
      </div>
    </div>;
}